import { DEFAULT_ERROR_MESSAGE } from 'config';

export type ErrorStatus = 'RETRY' | 'IGNORE' | 'ABORT' | 'OK';
export type Severity = 'ERROR' | 'WARNING' | 'FAILURE';
export type ErrorType = 'TECHNICAL' | 'BUSINESS';
export class CustomError {
  statusCode = 0;

  status: ErrorStatus | undefined;

  code: string | undefined;

  severity: Severity | undefined;

  type: ErrorType | undefined;

  description = DEFAULT_ERROR_MESSAGE;

  technicalDescription: string | undefined;

  transactionId: string | undefined;

  /**
   * Creates a generic client-side error
   * @param  {Partial<CustomError>} error
   * @returns CustomError
   */

  static fromJSON(error: Partial<CustomError>) {
    return Object.assign(new CustomError(), error);
  }

  static createClientError(error?: Partial<CustomError>): CustomError {
    return Object.assign(
      new CustomError(),
      {
        status: 'ABORT',
        code: 'CLIENT-ERROR',
        type: 'TECHNICAL',
        severity: 'ERROR',
        technicalDescription: '',
      } as Partial<CustomError>,
      error
    );
  }

  toString(): string {
    return this.description;
  }
}
